import script from "./CreateApprovalAuthorityPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateApprovalAuthorityPage.vue?vue&type=script&setup=true&lang=js"

import "./CreateApprovalAuthorityPage.vue?vue&type=style&index=0&id=6b6f0420&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b6f0420"]])

export default __exports__